import { Component } from '@angular/core';
import { CoreService } from 'src/app/data/datasource/local/core.service';
import { RouterModule } from '@angular/router';
import APP_CONSTANTS from "../../../../../core/commons/app-constants";

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  template: `
    <a [routerLink]="['/']">
      @if (logoExists) {
        <img
            src="./assets/images/logos/logo.svg"
            class="align-middle m-2"
            alt="logo"
            (error)="onImageError()"
        />
      } @else {
        <span class="align-middle m-2 fs-4">
          {{ enterpriseName }}
        </span>
      }
    </a>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  logoExists = false;
  enterpriseName = APP_CONSTANTS.ENTERPRISE_NAME
  constructor(private settings: CoreService) {}

  onImageError() {
    this.logoExists = false;
  }
}
